/* projects/portal/src/app/core/welcome-dialog.component.css */
.welcome-content {
  max-width: 480px;
}
.intro {
  margin: 0 0 16px;
  font-size: 14px;
  color: var(--ink-soft);
  line-height: 1.5;
}
.topic {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.topic-icon {
  color: var(--primary-color);
  flex: none;
}
.topic-title {
  font-weight: 500;
  color: var(--ink);
  margin-bottom: 2px;
}
.topic-body {
  font-size: 13px;
  color: var(--ink-soft);
  line-height: 1.45;
}
.notice {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fdf3e2;
  color: #8a5a12;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  margin: 4px 0 16px;
}
.notice mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  flex: none;
}
.footnote {
  margin: 0;
  font-size: 12px;
  color: var(--ink-muted);
}
/*# sourceMappingURL=welcome-dialog.component.css.map */
